type NewsEntry = {
  date: string;
  title: string;
  body: string;
};

const entries: NewsEntry[] = [
  {
    date: 'A fresh look',
    title: 'Welcome to the new Upward Bound site',
    body:
      'We have refreshed the site with a new look, updated facilities and the latest details for planning your stay. Take a look around the cabin and the Lakes Region.',
  },
  {
    date: 'Now available',
    title: 'Outdoor amenities ready for guests',
    body:
      'There is a gas grill, fire pit, sleds, outdoor seating, and more available for use during your stay — perfect for gathering outdoors in any season.',
  },
];

const News = () => {
  return (
    <section className="section">
      <div className="container container--narrow">
        <div className="section-head">
          <span className="eyebrow">News</span>
          <h2>What's new at the cabin.</h2>
        </div>

        <div className="news-list">
          {entries.map((e) => (
            <article className="news-item" key={e.title}>
              <time>{e.date}</time>
              <h3>{e.title}</h3>
              <p>{e.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default News;
